import { baseApi } from './base.api';
import { tasksApi } from './tasks.api';

export const versionApi = {
    ...baseApi,
    ...tasksApi,
};
